module.exports = __webpack_public_path__ + "static/media/ProximaNovaSoft-Regular.2ec51dbe.otf";